<template>
  <div class="pet-container">
    <!-- 顶部标题区域 -->
    <div class="header-container">
      <h1>AI一键生成人物手办</h1>
      <p>上传您的自拍照，AI将为您生成定制玩偶手办</p>
    </div>

    <!-- 示例区域 -->
    <div class="example-section">
      <div class="example-box">
        <div class="example-label">上传示例</div>
        <img src="@/assets/images/ashin.jpg" alt="上传示例">
      </div>
      <div class="arrow-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5L15 12L8 19" stroke="#FF6B00" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="example-box">
        <div class="example-label">效果示例</div>
        <img src="@/assets/images/ashin_toy.jpg" alt="效果示例">
      </div>
    </div>

    <!-- 操作区域 -->
    <div class="action-section">
      <div class="upload-area">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :auto-upload="false"
          :on-change="handleUpload"
          :show-file-list="false"
          :disabled="isGenerating" 
        >
          <div v-if="!previewImage" class="upload-placeholder">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将照片拖到此处，或<em>点击上传</em></div>
          </div>
          <div v-else class="preview-wrapper">
            <img :src="previewImage"  class="preview-image" :style="{ maxHeight: previewMaxHeight }">
          </div>
        </el-upload>
      </div>
      
      <div class="generate-area">
        <el-button
          type="primary"
          class="generate-btn"
          :disabled="!previewImage || isGenerating"
          @click="generateImage"
        >
          {{ isGenerating ? `生成中${'.'.repeat(dotCount + 1)}` : '开始生成' }}
        </el-button>
        <p class="generate-tip">
            {{ isGenerating ? 'AI正在努力生成中，可能需要3-5分钟，请保持网络畅通' : '生成可能需要3-5分钟，请耐心等待' }}
        </p>
      </div>
      
      <div class="result-preview">
        <div v-if="generatedImage" class="result-image-container">
          <img :src="generatedImage" alt="AI生成结果">
        </div>
        <div v-else class="result-placeholder">
        <!-- 新增生成中状态提示 -->
        <template v-if="isGenerating">
          <div class="loading-overlay">
            <div class="loading-spinner"></div>
          </div>
          <p class="generating-text">🎨 创作进行时</p>
          <p class="generating-tip">请勿关闭页面，您可以：</p>
          <ul class="tips-list">
            <li>👉 最小化窗口稍后回来</li>
            <li>👉 继续浏览其他内容</li>
            <li>👉 保持设备网络畅通</li>
          </ul>
        </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: 'PetPhotoGenerator',
  data() {
    return {
      previewImage: '',
      generatedImage: '',
      previewMaxHeight: '500px',
      dotCount: 0,
      dotInterval: null,
      // 新增生成状态标识
      isGenerating: false,
      uploadedFile: null  // 新增保存原始文件
    }
  },
  watch: {
    isGenerating(newVal) {
      if (newVal) {
        this.startDotAnimation()
      } else {
        this.clearDotAnimation()
      }
    }
  },
  methods: {
    handleUpload(file) {
    this.uploadedFile = file.raw;  // 保存原始文件对象

    if (!file.raw.type.match('image.*')) {
        this.$message({
          message: '请上传图片文件',
          type: 'error',
          offset:200
        });
        return;
    }
    
    // if (file.raw.size / 1024 / 1024 > 2) {
    //     this.$message({
    //       message: '图片大小不能超过2MB',
    //       type: 'error',
    //       offset:200
    //     });
    //     return;
    // }
    
    const reader = new FileReader();
    reader.onload = (e) => {
        this.previewImage = e.target.result;
        
        // 新增图片尺寸检测逻辑
        const img = new Image();
        img.onload = () => {
            // 计算最大显示高度（视口高度的70%）
            const viewportHeight = Math.max(
                document.documentElement.clientHeight || 0, 
                window.innerHeight || 0
            );
            // 取图片实际高度和视口限制高度的较小值
            this.previewMaxHeight = `${Math.min(
                img.naturalHeight, 
                viewportHeight * 0.7
            )}px`;
        };
        img.src = e.target.result;
    };
    reader.readAsDataURL(file.raw);
  },
    
    // 修改生成方法
    async generateImage() {
        // 开始生成时设置状态
        this.isGenerating = true;
        this.generatedImage = '';
        // 构建FormData
        const formData = new FormData();
        
        // 使用原始文件名（保留文件扩展名）
        const originalFileName = this.uploadedFile.name
        formData.append('image', this.uploadedFile)

        // 调用接口
        const response = await api.generateToyPhoto(formData)
        
        if (response.code === 200) {
            console.log(response);
          this.generatedImage = `${response.data}`
        }
        // 无论成功失败都重置状态
        this.isGenerating = false
    },
    startDotAnimation() {
      this.clearDotAnimation() // 清除已有定时器
      this.dotInterval = setInterval(() => {
        this.dotCount = (this.dotCount + 1) % 3
      }, 500)
    },
    clearDotAnimation() {
      if (this.dotInterval) {
        clearInterval(this.dotInterval)
        this.dotInterval = null
      }
      this.dotCount = 0
    },
  },
  beforeDestroy() {
    this.clearDotAnimation()
  }
}
</script>

<style scoped>
.pet-container {
  width: 100%;
  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
  background-color: #FFF9F2;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 顶部标题区域 */
.header-container {
  text-align: center;
  margin-bottom: 30px;
}

.header-container h1 {
  color: #FF6B00;
  font-size: 24px;
  margin-bottom: 10px;
  font-weight: 600;
}

/* src/assets/css/message.css */
.message-high { top: 20% !important; }
.message-middle { top: 50% !important; }
.message-low { top: 80% !important; }

/* 保持水平居中 */
.el-message {
  left: 50% !important;
  transform: translateX(-50%) !important;
}


.header-container p {
  color: #888;
  font-size: 16px;
}

/* 示例区域 */
.example-section {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.example-box {
    width: 240px;  /* 4:3比例的基础宽度 */
    position: relative;
  text-align: center;
  width: 180px;
}

.example-box img {
  width: 100%;
  aspect-ratio: 3/4;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.example-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.arrow-icon {
  color: #FF6B00;
}

/* 城市选择区域 */
/* 调整单选按钮样式保持与图片一致 */
.el-radio-button /deep/ .el-radio-button__inner {
  border-radius: 16px !important;
  padding: 8px 16px;
  margin: 0 12px 8px 0;
}

.el-radio-button.is-active /deep/ .el-radio-button__inner {
  background-color: #FF6B00;
  border-color: #FF6B00;
  box-shadow: none !important;
}

/* 操作区域 */
.action-section {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 70%;  /* 新增宽度设置 */
  margin: 0 auto;  /* 新增水平居中 */
  padding: 20px 0;
}

.upload-area {
  flex: 1;
  width: 100%;
  max-width: 300px; /* 限制最大宽度 */
}

.el-upload-dragger {
  width: 100%;
  height: auto !important;
  min-height: 200px;
  padding: 20px;
  border: 2px dashed #FFB088;
  border-radius: 12px;
  background-color: rgba(255, 176, 136, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.el-icon-upload {
  font-size: 40px;
  color: #FF8C66;
  margin-bottom: 15px;
}

.el-upload__text {
  color: #888;
  font-size: 14px;
}

.el-upload__text em {
  color: #FF6B00;
  font-style: normal;
  font-weight: 500;
}

/* 上传预览区域 */
.upload-placeholder {
  width: 100%;
  height:100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.preview-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.preview-image {
  width: 100%;
  height: auto;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 10px;
}

.generate-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
}

.generate-btn {
  background: linear-gradient(135deg, #FF8C66 0%, #FF6B00 100%);
  border: none;
  border-radius: 20px;
  padding: 12px 24px;
  font-size: 16px;
  color: white;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.2);
}

.generate-tip {
  color: #AAA;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.result-preview {
  flex: 1;
  position: relative;
  max-width: 300px; /* 与上传区域对称 */
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #FFB088;
  border-radius: 12px;
  background-color: rgba(255, 176, 136, 0.05);
}

.result-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 3/4; /* 保持竖屏比例 */
  border-radius: 8px;
}

.result-placeholder {
  color: #888;
  font-size: 14px;
}

/* 新增加载动画样式 */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  z-index: 1; 
}

.loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #FF6B00;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}


@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 768px) {
  .action-section {
    flex-direction: column;
    width: 90%;  /* 小屏幕下稍宽 */
    gap: 15px;
  }
  
  .generate-area {
    width: 100%;
    margin: 15px 0;
  }

  /* 配套调整父容器 */
  .upload-area {
    width: 100%;
    max-width: 100%;
  }

 .upload-area /deep/ .el-upload-dragger {
    width: 100% !important;  /* 强制覆盖组件库的固定宽度 */
    max-width: 100vw;        /* 防止溢出视口 */
    min-width: unset !important;  /* 移除默认最小宽度限制 */
  }

  .result-preview {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 30vh;
    order: 3;
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/AiToy.vue